var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "invoice-grid row-subtotal row-subtotal--skeleton" },
      [
        _c("div", { staticClass: "subtotal-label" }, [
          _c("div", { staticClass: "skeleton skeleton-subtotal" })
        ]),
        _c("div", { staticClass: "text-right" }, [
          _c("div", { staticClass: "skeleton skeleton-amount skeleton-right" })
        ]),
        _c("div", { staticClass: "text-right" }, [
          _c("div", { staticClass: "skeleton skeleton-amount skeleton-right" })
        ]),
        _c("div")
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }